
export const pwindow = typeof(window) !== "undefined" && window

export const isMobile = () => pwindow.innerWidth < 840
